import React from 'react';
import { useDeleteBookMutation } from '../features/books/bookAPISlice';

const Modal = ({ onClose, children ,bookId}) => {
  const [deletBook, {isLoading,data,isSuccess, error}] =useDeleteBookMutation();

  let content=null;
if(isLoading){
  content=<p>Loading...</p>
}
if(isSuccess){
  onClose()
  content=<p>Succesfully deleted this book...</p>

}
if(!isLoading){
  content= children

}

  return (
    <div className="modal">
      <div className="modal-content">
        {content}
     
        <button  onClick={()=>{onClose()}}  className={`lws-filter-btn  active-filter `} style={{marginRight:'10px',marginTop:"20px"}} >   Close</button>
        <button  onClick={()=>{deletBook(bookId)}}  className={`lws-filter-btn  active-filter`} style={{background:'red'}} >   Confirm</button>
        
      </div>
    </div>
  );
};

export default Modal;